<template>
  <div class="insc-root">
    <AppHeader />
    <div class="insc-content">
      <!-- Page Header -->
      <div class="insc-page-header">
        <span class="insc-badge">📋 Inscripciones</span>
        <h1 class="insc-title">Cargadores</h1>
        <p class="insc-subtitle">Listado de cargadores inscritos en la procesión</p>
      </div>

      <v-overlay :value="loading" color="var(--sys-bg)" opacity="0.9">
        <div class="insc-loading">
          <div class="insc-spinner"></div>
          <span>Cargando...</span>
        </div>
      </v-overlay>

      <div class="insc-table-wrap">
        <AppTable :cargadores="Listacargadores" ref="tableComponent" />
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/HeaderC.vue'
import AppTable from '@/components/TableC.vue'
import axios from 'axios'

export default {
  name: 'InscripcionesView',
  data() {
    return {
      Listacargadores: [],
      loading: false,
      validToken: false
    }
  },
  components: {
    AppHeader,
    AppTable
  },
  mounted: function () {
    this.obtieneRegistros();
  },
  methods: {
    validateToken() {
      const token = this.$cookies.get('token');
      this.loading = true;
      const apiUrl = `https://wm1xvvtarj.execute-api.us-east-1.amazonaws.com/dev/validateToken?token=${token}`;
      return axios.get(apiUrl)
        .then(response => {
          const username = response.data.decoded.username;
          this.$cookies.set('username', username, '1d', '', '', true, 'Strict');
          this.validToken = true;
          this.loading = false;
        })
        .catch(() => {
          this.validToken = false;
          this.loading = false;
        });
    },
    clearAllCookies() {
      const allCookies = this.$cookies.keys();
      for (const cookie of allCookies) { this.$cookies.remove(cookie); }
    },
    async obtieneRegistros() {
      await this.validateToken();
      if (!this.validToken) { this.clearAllCookies(); return; }
      const apiUrl = `https://62jecp6v6f.execute-api.us-east-1.amazonaws.com/dev/api/cargadores?usuarioResponsable=${this.$cookies.get('username')}`;
      const token = this.$cookies.get('token');
      const config = { headers: { Authorization: `Bearer ${token}` } };
      this.loading = true;
      axios.get(apiUrl, config)
        .then(response => {
          this.Listacargadores = response.data.records[0];
          this.loading = false;
        })
        .catch(() => { this.loading = false; });
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');

.insc-root {
  font-family: 'Inter', sans-serif;
  min-height: 100vh;
  background: var(--sys-bg);
}

.insc-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 90px 32px 60px;
}

.insc-loading {
  display: flex; flex-direction: column; align-items: center; gap: 14px;
  color: var(--sys-text-secondary); font-size: 0.9rem;
}
.insc-spinner {
  width: 36px; height: 36px;
  border: 3px solid rgba(123,47,247,0.3);
  border-top-color: #7b2ff7;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }

.insc-page-header { margin-bottom: 32px; }
.insc-badge {
  display: inline-block;
  background: rgba(123,47,247,0.15);
  border: 1px solid rgba(123,47,247,0.35);
  color: #c4a0ff;
  padding: 5px 14px;
  border-radius: 100px;
  font-size: 0.78rem;
  font-weight: 600;
  margin-bottom: 12px;
  letter-spacing: 0.03em;
}
.insc-title {
  font-size: clamp(1.6rem, 3vw, 2.2rem);
  font-weight: 800;
  color: var(--sys-text-primary);
  margin-bottom: 6px;
}
.insc-subtitle {
  color: var(--sys-text-secondary);
  font-size: 0.95rem;
  margin: 0;
}

.insc-table-wrap {
  background: var(--sys-card-bg);
  border: 1px solid var(--sys-card-border);
  border-radius: 18px;
  padding: 8px;
  backdrop-filter: blur(12px);
  overflow: hidden;
}

::v-deep .v-data-table { background: transparent !important; }
::v-deep .v-data-table .v-data-table__wrapper table { background: transparent !important; }
[data-theme="dark"] ::v-deep .v-data-table thead tr th {
  background: rgba(123,47,247,0.12) !important;
  color: rgba(255,255,255,0.7) !important;
}
::v-deep .v-data-table thead tr th {
  background: var(--sys-table-header) !important;
  color: var(--sys-text-secondary) !important;
  font-family: 'Inter', sans-serif !important;
  font-weight: 600 !important;
  font-size: 0.78rem !important;
  text-transform: uppercase !important;
  letter-spacing: 0.05em !important;
  border-bottom: 1px solid var(--sys-card-border) !important;
}
::v-deep .v-data-table tbody tr { background: transparent !important; transition: background 0.2s !important; }
::v-deep .v-data-table tbody tr:hover { background: var(--sys-table-row-hover) !important; }
::v-deep .v-data-table tbody tr td {
  color: var(--sys-text-primary) !important;
  font-family: 'Inter', sans-serif !important;
  font-size: 0.88rem !important;
  border-bottom: 1px solid var(--sys-card-border) !important;
}
::v-deep .v-data-footer {
  background: transparent !important;
  border-top: 1px solid var(--sys-card-border) !important;
  color: var(--sys-text-secondary) !important;
}
::v-deep .v-data-footer .v-select__selection {
  color: var(--sys-text-primary) !important;
}

@media (max-width: 768px) {
  .insc-content { padding: 80px 16px 40px; }
}
</style>